export const ADMIN_RUNTIME_COMMANDS = Object.freeze({
  SETTINGS_V2_LOAD: 'settings.v2.load',
  SETTINGS_V2_LOAD_DEFAULTS: 'settings.v2.loadDefaults',
  SETTINGS_V2_VALIDATE: 'settings.v2.validate',
  SETTINGS_V2_SAVE_DRAFT: 'settings.v2.saveDraft',
  SETTINGS_V2_DESCRIBE: 'settings.v2.describe',
  SETTINGS_V2_COMPONENTS: 'settings.v2.components',
  SETTINGS_V2_DEPLOYMENT_STATUS: 'settings.v2.deploymentStatus',
  SETTINGS_V2_COPY_TO_PRODUCTION: 'settings.v2.copyToProduction',
  SETTINGS_PREVIEW_SAVED: 'settings.preview.saved',
  ONBOARDING_MODE_SELECTED: 'onboarding.modeSelected',
  ONBOARDING_INTEGRATION_CONFIGURED: 'onboarding.integrationConfigured',
  LIVE_SET_ENABLED: 'live.setEnabled',
  BUNDLE_BUILD_PREVIEW: 'bundle.buildPreview',
  BUNDLE_BUILD_AND_PROMOTE: 'bundle.buildAndPromote',
  CRAWLER_CONNECTIVITY_CHECK: 'crawler.connectivity.check',
  CRAWLER_SETTINGS_SAVE: 'crawler.settings.save',
  ANALYTICS_REPORT: 'analytics.report',
  OPERATOR_STATE: 'operator.state',
  INDEXING_STATUS: 'indexing.status',
  INDEXING_HISTORY: 'indexing.history',
  INDEXING_START: 'indexing.start',
  INDEXING_MARK_REQUIRED: 'indexing.mark_required',
  INDEXING_KICK: 'index.kick',
  INDEXING_RESTART_STALE: 'index.restart_stale',
  PREVIEW_RESOLVE_URL: 'preview.resolveUrl',
});

export class UnsupportedRuntimeCommandError extends Error {
  constructor(command, productId) {
    super(`Command "${command}" is not supported by the ${productId} admin runtime.`);
    this.name = 'UnsupportedRuntimeCommandError';
    this.command = command;
    this.productId = productId;
  }
}

/**
 * Small command boundary shared by cloud and plugin admin products.
 *
 * Commands express operator intent. Transport details and environment-specific
 * side effects live in handlers supplied by the product adapter.
 */
export function createAdminRuntime({ productId, handlers }) {
  if (!productId) throw new Error('productId is required');
  if (!handlers || typeof handlers !== 'object') throw new Error('handlers are required');

  const supports = command => typeof handlers[command] === 'function';

  return Object.freeze({
    productId,
    supports,
    async sendMessageWithResponse(command, payload = {}) {
      if (!supports(command)) {
        throw new UnsupportedRuntimeCommandError(command, productId);
      }
      return handlers[command](payload);
    },
  });
}
